export const GetJobDataForUser = `
    query GetJobDataForUser(
        $userId: String!
    ) {
        getUserById(userId: $userId) {
            company {
              id
              profile {
                name
                bio
              }
              jobPostings {
                aboutUs
                companyName
                companyId
                companyProfile {
                  name
                }
                department
                description
                experience
                id
                roleType
                jobTitle
                status
                remotePolicy
                timezonePolicy
                digitalNomadFriendly
                timezoneRanges {
                  start 
                  end
                }
                officeFrequency {
                  daysPerMonth
                  daysPerWeek
                }
                officeLocations {
                  formatted_address
                  coordinate {
                    lat
                    lon
                  }
                }
                willSponsor
                communications {
                  emails
                  phone
                }
                dateCreated
                dateModified
              }
            }
        }        
    }
`

export const GetJobPolicyDataForUser = `
    query GetJobPolicyDataForUser(
        $userId: String!
    ) {
        getUserById(userId: $userId) {
            company {
              id
              jobPostings {
                id
                status
                remotePolicy
                timezonePolicy
                digitalNomadFriendly
                timezoneRanges {
                  start 
                  end
                }
                officeFrequency {
                  daysPerMonth
                  daysPerWeek
                }
                officeLocations {
                  formatted_address
                  coordinate {
                    lat
                    lon
                  }
                }
              }
            }
        }        
    }
`

export const GetJobSettingsDataForUser = `
    query GetJobPolicyDataForUser(
        $userId: String!
    ) {
        getUserById(userId: $userId) {
            company {
              id
              ownerEmail
              jobPostings {
                id
                status
                willSponsor
                communications {
                  emails
                  phone
                }
              }
            }
        }        
    }
`

export const getCompanyDataForUser = /* GraphQL */ `
  query GetCompanyDataForUser($userId: String!) {
    getUserById(userId: $userId) {
      id
      emailVerified
      email
      company {
        id
        profile {
          industries
          remotePolicy
          name
          bio
          hasHeadquarters
          hqAddress {
            formatted_address
            coordinate {
              lat
              lon
            }
          }
          emailAddress
          phoneNumber
        }
      }
    }
  }
`;

export const getCandidateById = /* GraphQL */ `
  query GetCandidateById($userId: String!) {
    getUserById(userId: $userId) {
      id
      email
      emailVerified
      phoneVerified
      group
      onboardingCompleted
      firstName
      lastName
      age
      jobSeeker {
        id
        userId
        autoApply {
          subId
          cancelled          
          isActive
        }
        city {
          formatted_address
          coordinate {
            lat
            lon
          }
        }
        newGradOrStudent
        linkedin
        website
        currentCompany
        currentTitle
        profileComplete
        fullTime
        partTime
        contractor
        fullRemote
        hybridRemote
        remoteOptional
        desiredRole
        salaryRequirement {
          currencyCode
          value
        }
        authorization {
          usAuthorized
          requireSponsorshipUS
        }
        preferencesComplete
        workHistory {
          company
          title
          startDate
          endDate
          currentJob
          description
        }
        educationHistory {
          institution
          certification
          concentration
          dateStarted
          dateCompleted
          inProgress
          description
        }
        firstName
        lastName
        notificationSettings {
          reviewsProfile
        }
        visibleToEmployers
        emailAddress
        phone
        resume {
          id
          name
          fileType
          size
          url
          dateUploaded
        }     
        profilePic
        dateCreated
        dateModified
      }
    }
  }
`;

export const getEmployerById = /* GraphQL */ `
  query GetEmployerById($userId: String!) {
    getUserById(userId: $userId) {
      id
      email
      emailVerified
      companyId
      group
      onboardingCompleted
      firstName
      lastName
      age
      company {
        id
        dateCreated
        dateModified
        ownerId
        ownerEmail
        profile {
          industries
          remotePolicy
          name
          bio
          hasHeadquarters
          hqAddress {
            formatted_address
            coordinate {
              lat
              lon
            }
          }
          emailAddress
          phoneNumber
        }
        jobPostings {
          id
          companyId
          roleType
          jobTitle
          department
          experience
          companyName
          description
          aboutUs
          status
          remotePolicy
          timezonePolicy
          digitalNomadFriendly
          timezoneRanges {
            start
            end
          }
          officeFrequency {
            daysPerMonth
            daysPerWeek
          }
          officeLocations {
            formatted_address
            coordinate {
              lat
              lon
            }
          }
          willSponsor
          communications {
            emails
            phone
          }
          dateCreated
          dateModified
        }
      }
    }
  }
`;

export const getNotificationsForUser = /* GraphQL */ `
  query GetUserById($userId: String!) {
    getUserById(userId: $userId) {
      notifications {
        id
        notificationType
        message
        userId
        url
        read
        dateCreated
        dateRead
      }
    }
  }
`;

export const getJobApplicationsForUser = /* GraphQL */ `
  query GetUserById($userId: String!) {
    getUserById(userId: $userId) {
      jobSeeker {
        applications {
          id
          jobId
          dateApplied
          job {
            id
            companyName
            companyId
            jobTitle
            description
            department
            officeLocations {
              formatted_address
              coordinate {
                lat
                lon
              }
            }
            companyProfile {
              name
              image
            }
          }
        }
      }
    }
  }
`;

export const getJobSeekerIdForUser = /* GraphQL */ `
  query GetUserById($userId: String!) {
    getUserById(userId: $userId) {
      jobSeeker {
        id
      }
    }
  }
`;

export const getJobSeekerIdAutoForUser = /* GraphQL */ `
  query GetUserById($userId: String!) {
    getUserById(userId: $userId) {
      jobSeeker {
        id
        autoApply {
          isActive
          cancelled
          subId
          id
          dateCreated
        }
      }
    }
  }
`;

export const getCandidatePreferences = /* GraphQL */ `
  query GetUserById($userId: String!) {
    getUserById(userId: $userId) {
      id
      email
      jobSeeker {
        id
        firstName
        lastName
        emailAddress
        phone
        notificationSettings {
          reviewsProfile
        }
        visibleToEmployers
      }
    }
  }
`;

export const getApplicationsForJobSeekerIdByStatus = /* GraphQL */ `
  query GetApplicationsForJobSeekerIdByStatus(
    $jobSeekerId: ID
    $status: ApplicationStatus
    $first: Int
    $after: ApplicationCursorInput
    $last: Int
    $before: ApplicationCursorInput
  ) {
    getApplicationsForJobSeekerIdByStatus(
      jobSeekerId: $jobSeekerId
      status: $status
      first: $first
      after: $after
      last: $last
      before: $before
    ) {
      edges {
        node {
          id
          jobId
          jobSeekerId
          applicationStatus
          job {
            id
            companyId
            companyProfile {
              image
              name
            }
            roleType
            jobTitle
            department
            experience
            companyName
            description
            aboutUs
            status
            remotePolicy
            timezonePolicy
            digitalNomadFriendly
            officeLocations {
              formatted_address
              coordinate {
                lat
                lon
              }
            }
            jobLogo
            willSponsor
            dateCreated
            dateModified
            deleted
          }
          dateApplied
          dateUpdated
        }
        cursor {
          id
          jobSeekerId
        }
      }
      pageInfo {
        startCursor {
          id
          jobSeekerId
        }
        endCursor {
          id
          jobSeekerId
        }
        hasNextPage
        hasPreviousPage
      }
    }
  }
`;

export const getApplicationsForJobIdByStatus = /* GraphQL */ `
  query GetApplicationsForJobIdByStatus(
    $jobId: ID
    $status: ApplicationStatus
    $first: Int
    $after: ApplicationJobIdCursorInput
    $last: Int
    $before: ApplicationJobIdCursorInput
  ) {
    getApplicationsForJobIdByStatus(
      jobId: $jobId
      status: $status
      first: $first
      after: $after
      last: $last
      before: $before
    ) {
      edges {
        node {
          id
          jobId
          jobSeekerId
          applicationStatus
          job {
            id
            companyId
            roleType
            jobTitle
            department
            experience
            companyName
            description
            aboutUs
            status
            remotePolicy
            timezonePolicy
            digitalNomadFriendly
            willSponsor
            dateCreated
            dateModified
            deleted
          }
          applicant {
            id
            userId
            firstName
            lastName
            city {
              formatted_address
              coordinate {
                lat
                lon
              }
            }
            newGradOrStudent
            linkedin
            website
            currentCompany
            currentTitle
            fullTime
            partTime
            contractor
            fullRemote
            hybridRemote
            remoteOptional
            desiredRole
            visibleToEmployers
            emailAddress
            phone
            profilePic
            workHistory {
              company
              title
              startDate
              endDate
              currentJob
              description
            }
            educationHistory {
              institution
              certification
              concentration
              dateStarted
              dateCompleted
              inProgress
              description
            }            
            preferencesComplete
            profileComplete
            dateCreated
            dateModified
            deleted
          }
          dateApplied
          dateUpdated
        }
        cursor {
          id
          jobId
        }
      }
      pageInfo {
        startCursor {
          id
          jobId
        }
        endCursor {
          id
          jobId
        }
        hasNextPage
        hasPreviousPage
      }
    }
  }
`;

export const updateApplication = /* GraphQL */ `
  mutation UpdateApplication($input: UpdateApplicationInput) {
    updateApplication(input: $input) {
      id
      applicationStatus
    }
  }
`;

export const getOnboardingCompleted = /* GraphQL */ `
  query GetEmployerById($userId: String!) {
    getUserById(userId: $userId) {
      onboardingCompleted
    }
  }
`;

export const getEmployerByIdWithoutPostings = /* GraphQL */ `
  query GetEmployerById($userId: String!) {
    getUserById(userId: $userId) {
      id
      email
      emailVerified
      companyId
      group
      onboardingCompleted
      firstName
      lastName
      age
      company {
        id
        dateCreated
        dateModified
        ownerId
        ownerEmail
        profile {
          industries
          remotePolicy
          name
          bio
          hasHeadquarters
          hqAddress {
            formatted_address
            coordinate {
              lat
              lon
            }
          }
          emailAddress
          phoneNumber
          image
        }
      }
    }
  }
`;

export const updateEmployerProfilePage = /* GraphQL */ `
  mutation UpdateEmployerProfile($employerProfileInput: EmployerProfileInput) {
    updateEmployerProfile(employerProfileInput: $employerProfileInput) {
      id
      profile {
        industries
        remotePolicy
        name
        bio
        hasHeadquarters
        hqAddress {
          formatted_address
          coordinate {
            lat
            lon
          }
        }
        emailAddress
        phoneNumber
        image
      }
    }
  }
`;